module.exports = __webpack_public_path__ + "img/credit-card.40c6c3db.svg";